export interface ShowErrorModalDetails {
  isSilent?: boolean;
  status?: number;
}

type Listener = (details: ShowErrorModalDetails) => void;
type RetryCallback = () => void;

let listener: Listener | null = null;
let retryErrorCount = 0;
let retryPhase = false;
const retryCallbacks = new Set<RetryCallback>();

export function subscribeErrorModal(fn: Listener): () => void {
  listener = fn;
  return () => {
    if (listener === fn) listener = null;
  };
}

export function subscribeRetry(fn: RetryCallback): () => void {
  retryCallbacks.add(fn);
  return () => {
    retryCallbacks.delete(fn);
  };
}

export function beginRetryPhase(): void {
  retryPhase = true;
  retryErrorCount = 0;
}

export function endRetryPhase(): number {
  retryPhase = false;
  const count = retryErrorCount;
  retryErrorCount = 0;
  return count;
}

export function fireRetryCallbacks(): void {
  retryCallbacks.forEach((fn) => fn());
}

export function showErrorModal(details: ShowErrorModalDetails = {}): void {
  if (retryPhase) {
    retryErrorCount++;
    return;
  }
  if (listener != null) {
    listener(details);
  }
}
